import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { TrainersViewListingModel } from 'common/models/page-models/Trainers View Model/trainers-view-grid-params.model';

import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TrainerViewGridWidgetService } from 'common/widget/assignment/trainers-view-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class TrainerViewGridResolver extends GridResolver<AssignmentModel, TrainersViewListingModel> {
    constructor(
        protected fs: TrainerViewGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }


}
